import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import servicesObjects from 'shared/constants/services';
import cx from 'classnames';

import s from './DealerServices.css';

class DealerServices extends React.Component {
  static propTypes = {
    services: PropTypes.shape().isRequired,
    // cn: PropTypes.shape({
    //   root: PropTypes.string,
    //   item: PropTypes.string,
    // }),
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    cn: null,
  };

  render() {
    const { services /* , cn = {} */, intl } = this.props;
    const servicesArray = services
      ? Object.entries(services).map(([key, value]) => ({
          slug: key,
          status: value,
        }))
      : [];

    return (
      <div className={cx(s.root, { [s.root]: s.root })}>
        {servicesArray.length > 0 &&
          servicesArray.map(({ slug, status }) => {
            const serviceObj = servicesObjects[slug] || null;

            if (!serviceObj || !status) {
              return null;
            }

            const { title, icon, description } = serviceObj;
            const transformedDescription = intl.formatMessage({ id: description });

            return (
              <div key={slug} className={cx(s.serviceItem)} title={transformedDescription}>
                <div className={s.info}>
                  <img className={s.icon} alt={''} src={icon} />
                  <h3 className={s.title}>
                    <FormattedMessage id={title} />
                  </h3>
                </div>
              </div>
            );
          })}
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(DealerServices));



// WEBPACK FOOTER //
// ./src/shared/components/DealerServices/DealerServices.js